import { render } from "./MountpointDisplay.vue?vue&type=template&id=e85e14fa"
import script from "./MountpointDisplay.vue?vue&type=script&lang=js"
export * from "./MountpointDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__